import { Switch } from '@/components/ui/switch';
import { useSmsChatbot } from '@/features/campaigns/api/use-sms-chatbot';

export function SmsChatbotToggle() {
  const { query, mutation } = useSmsChatbot();
  // Fail closed: do not expose the control to organisations outside the
  // countries shared SMS serves (UK and Ireland; the US only once Osis is on
  // for the clinic), or to one that already has its own dedicated (legacy)
  // SMS number. Which sender a given MESSAGE goes out from is a separate,
  // recipient-based decision at dispatch time (resolveSharedSmsSender) —
  // this only gates whether the clinic can opt in at all.
  if (!query.data?.visible) return null;
  return (
    <div className="flex items-center justify-between gap-4 rounded-lg border p-3">
      <div>
        <p className="text-sm font-medium">SMS</p>
        <p className="text-xs text-muted-foreground">
          Contact new eligible lead-form enquiries by SMS and let Claire reply.
          SMS takes priority over WhatsApp. Applies to your whole organisation.
        </p>
        {!query.data.available && (
          <p className="text-xs text-muted-foreground">
            SMS rollout is not available for this clinic yet.
          </p>
        )}
      </div>
      <Switch
        aria-label="Enable SMS assistant"
        checked={query.data.enabled}
        disabled={
          mutation.isPending || (!query.data.available && !query.data.enabled)
        }
        onCheckedChange={(enabled) => mutation.mutate(enabled)}
      />
    </div>
  );
}
